import {useRouteMatch} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {translations} from '../../i18n/translations';
import {BarChart, Dashboard, ViewComfyRounded} from '@mui/icons-material';
import {ListItemLink} from '../list-item-link/list-item-link';
import {ScreenPaths} from '../../enums';
import {useAuth} from '../../contexts/auth/context';
import {RolePermissionType} from '../../backend/enums/role-permission-type';

export interface DashboardanelComponentsProps {
  showExpanded?: boolean;
}

export const DashboardSidePanelComponents = ({
  showExpanded: sidePanelExpanded,
}: DashboardanelComponentsProps) => {
  const {t} = useTranslation();
  const {url} = useRouteMatch();
  const {hasReadPermission} = useAuth();

  // Main list styling
  const listItemsSx = {
    width: '180px',
    height: '40px',
    boxShadow: 'none',
    mx: '11px',
    px: '4px',
    '& .MuiTypography-root': {
      textOverflow: 'ellipsis',
      maxWidth: '100%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      fontSize: '14px',
      fontWeight: 500,
    },
  };

  // Dropdown list styling
  const dropdownListItemsSx = {
    ...listItemsSx,
    color: '#747474',
    backgroundColor: '#F9FBFF',
    paddingLeft: sidePanelExpanded ? '22px' : '0px',
    paddingRight: '0px',
    '& .MuiTypography-root': {
      fontSize: '12px',
      fontWeight: 500,
      color: '#747474',
    },
    '& .MuiSvgIcon-root': {
      fontSize: '15px',
      color: '#747474',
    },
    '&:hover': {
      filter: 'brightness(95%)',
      backgroundColor: '#F9FBFF',
    },
  };

  return (
    <>
      <ListItemLink
        showTooltip={!sidePanelExpanded}
        to={url}
        primary={t(translations.dashboard_side_menu.dashboard)}
        icon={<Dashboard />}
        expanded={sidePanelExpanded}
        teamSideMenuDropdown
        teamFirstChild
        sx={listItemsSx}
      />
      {hasReadPermission(RolePermissionType.Overview_Activity) && (
        <ListItemLink
          showTooltip={!sidePanelExpanded}
          to={`${url}${ScreenPaths.ProfessionalCaregiver_Activity}`}
          primary={t(translations.dashboard_side_menu.general_activity)}
          icon={<ViewComfyRounded />}
          teamProfileDropdown
          sx={dropdownListItemsSx}
        />
      )}
      {hasReadPermission(RolePermissionType.Overview_Statistics) && (
        <ListItemLink
          showTooltip={!sidePanelExpanded}
          to={`${url}${ScreenPaths.ProfessionalCaregiver_Statistics}`}
          primary={t(translations.dashboard_side_menu.general_statistics)}
          icon={<BarChart />}
          teamProfileDropdown
          sx={dropdownListItemsSx}
        />
      )}
    </>
  );
};
